var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.569 3.344a.533.533 0 0 1 .754.024l4 4.267a.533.533 0 0 1 0 .73l-4 4.266a.533.533 0 1 1-.778-.73L10.203 8 6.545 4.098a.533.533 0 0 1 .024-.754",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRight;